import { ModelValue, nonRegularFieldName, ViewModel, ViewModelFieldName } from "../../../Core/CoreTypes";
import { IFormModelAccessor } from "../../IFormModelAccessor";

import { IFormHookModelAccessor } from "./IFormHookCallContext";

export class FormHookModelAccessor implements IFormHookModelAccessor {
    readonly #modelAccessor: IFormModelAccessor;

    public constructor(modelAccessor: IFormModelAccessor) {
        this.#modelAccessor = modelAccessor;
    }

    public getCached(path: string): ViewModel;
    public getCached(path: string, name: "children"): string[] | undefined;
    public getCached(path: string, name: "errorsCount" | "warningsCount"): number | undefined;
    public getCached(path: string, name: string): ModelValue;
    public getCached(
        path: string,
        name?: "children" | "errorsCount" | "warningsCount" | string
    ): ViewModel | string[] | undefined | number | ModelValue {
        if (name == undefined) {
            return this.#modelAccessor.getViewModel(path);
        }

        return this.#modelAccessor.getViewModelField(path, nonRegularFieldName(name));
    }

    public setCached(path: string, name: ViewModelFieldName, value: ModelValue): void {
        this.#modelAccessor.setViewModelField(path, name, value);
    }
}
